import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../dashboard.service';
import { helper } from 'src/environments/helper';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-cetatean-upload',
    templateUrl: './cetatean-upload.component.html',
    styleUrls: ['./cetatean-upload.component.scss'],
})
export class CetateanUploadComponent implements OnInit {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;

    helper = helper;
    isLoading: boolean = false;
    isUploading: boolean = false;

    uploadForm!: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            id: number;
        },
        private docService: DashboardService,
        private fb: FormBuilder,
        private dialogRef: MatDialogRef<CetateanUploadComponent>,
        private notificationService: NotificationService,
    ) {}

    ngOnInit() {
        this.uploadForm = this.fb.group({
            exemplarCetatean: new FormControl(null, Validators.required),
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    removeFile() {
        this.uploadForm.get('exemplarCetatean')?.reset();
        const fileInput = document.getElementById(
            'upload-cetatean-file-input'
        ) as HTMLInputElement;

        if (fileInput) {
            fileInput.value = '';
        }
    }

    addFile(event: any) {
        event.preventDefault();
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files || inputElement.files.length === 0) {
            return;
        }

        const file = inputElement.files[0];
        this.isUploading = true;

        const formData = new FormData();
        formData.append('exemplarCetatean', file, file.name);

        this.docService.fileUpload(formData).subscribe({
            next: (result: any) => {
                if (result && result.status_code === 200 && result.data) {
                    this.uploadForm.get('exemplarCetatean')?.setValue(result.data);
                    this.isUploading = false;
                } else {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                    this.isUploading = false;
                }
            },
            error: (error: any) => {
                this.isUploading = false;
                this.onHttpError(error);
            },
        });
    }

    submit() {
        if (this.uploadForm.invalid) {
            return;
        }

        this.isLoading = true;
        const exemplarCetatean = this.uploadForm.get('exemplarCetatean')?.value;

        this.docService
            .setCetateanExemplar(this.data.id, {
                exemplarCetatean: [exemplarCetatean],
            })
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res: any) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err: any) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    try {
                        errorMessage = err.error?.errors?.message?.[0] || errorMessage;
                    } catch (e) {}
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }

    private onHttpError(error: any) {
        let errorMessage =
            environment.config.customNotifications.generalMessages.error;
        try {
            errorMessage = error.error?.errors?.message?.[0] || errorMessage;
        } catch (e) {}
        this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
        );
    }
}
